// extracted by mini-css-extract-plugin
export default {"img_message":"styles_img_message__cXsVg","img_container":"styles_img_container__mJKxC","link":"styles_link__r8kXe"};